import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

import { truncateValue } from '~/utils/helpers';
import GraphTooltip from '~/views/dashboard/DashboardPage/components/AudiencesSection/components/GraphTooltip';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { BarChartBlock } from './blockTypes';
import { formatCompactNumber } from './chartAxis';
import {
  BAR_CATEGORY_LABEL_MAX_CHARS,
  BAR_LEGEND_OFFSET_LEFT,
  BAR_MARGIN_LEFT,
  LABEL_SKIP_WIDTH,
  LEGEND_OFFSET_BOTTOM_NORMAL,
} from './chartConfig';

interface Props {
  block: BarChartBlock;
}

const SimpleBarChart = ({ block }: Props) => {
  const data = block.data.map((d) => ({ label: d.label, value: d.value }));

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveBar
          data={data}
          keys={['value']}
          indexBy="label"
          layout="horizontal"
          margin={{ top: 20, right: 30, bottom: 50, left: BAR_MARGIN_LEFT }}
          axisBottom={{
            legend: block.yLabel,
            legendPosition: 'middle',
            legendOffset: LEGEND_OFFSET_BOTTOM_NORMAL,
            format: (v) => formatCompactNumber(Number(v)),
          }}
          axisLeft={{
            legend: block.xLabel,
            legendPosition: 'middle',
            legendOffset: BAR_LEGEND_OFFSET_LEFT,
            format: (v) => truncateValue(String(v), BAR_CATEGORY_LABEL_MAX_CHARS), // see docs/ai-insights-chart-rendering.md §4
          }}
          animate={true}
          colors={['#f97316']}
          labelSkipWidth={LABEL_SKIP_WIDTH}
          tooltip={(data) => <GraphTooltip dataKey={data.indexValue as string} count={data.value} />}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleBarChart;
